var Glyphicon = require("components/utility/icons/Glyphicon");
var CommentForm = require("components/social/comments/CommentForm");
var CurrentUser = require("lib/account/CurrentUser");
var ReactTooltip = require("react-tooltip");

class CommentLine extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			editMode: false
		};
	}

	onDeleteClick(e) {
		$wr.nope(e)
		if (confirm('Are you sure you want to delete this comment?')) {
			this.props.deleteComment(this.props.comment);
		}
	}

	openEdit(e) {
		$wr.nope(e)
		this.props.closeEditComments();
		setTimeout(function() {
			this.setState({ editMode: true });
		}.bind(this), 20);
	}

	closeEdit() {
		this.setState({ editMode: false });
	}

	getCommentInfoLine() {
		var comment = this.props.comment;
		var date = $wr.formatDate(comment.created_at);

		if (comment.secretive) {
			var secretive = (
				<span>
					| <Glyphicon icon="eye-close" dataTip="Private comment" />
					<ReactTooltip effect="solid" />
				</span>
			)
		}
		if (CurrentUser.hasID(comment.user_id)) {
			var editControl = (
				<span>
					| <a href="#" onClick={ this.openEdit }>Edit</a>
				</span>
			)
		}

		if (CurrentUser.hasID(comment.user_id) || CurrentUser.isAdmin()) {
			var deleteControl = (
				<span>
					| <a href="#" onClick={ this.onDeleteClick }>Delete</a>
				</span>
			)
		}

		return (
			<span className="commentInfoLine">
				{ date } { secretive } { editControl } { deleteControl }
			</span>
		)
	}

	onUpdateSubmit(commetData) {
		this.refs.editCommentForm.reset();
		this.props.updateComment(commetData);
		this.setState({ editMode: false });
	}

	render() {
		var comment = this.props.comment;

		if (this.state.editMode) {
			var content = (
				<div className="commentEdit">
					<CommentForm comment={ comment } onSubmit={ this.onUpdateSubmit }
						ref="editCommentForm" />
				</div>
			);

		} else {
			var content = (
				<div className="commentDisplay">
					<div className="content">
						<span className="commenter">
							{ comment.user.display_name }{ " " }
						</span>
						
						{ comment.body }

						<br />
						{ this.getCommentInfoLine() }
					</div>
				</div>
			)
		}
		return (
			<div className="commentRow">
				{ content }
			</div>
		)
	}
};

CommentLine.propTypes = StrictPropTypes({
	// The comment the line is displaying
	comment: PropTypes.object.isRequired,

	closeEditComments: PropTypes.func,
	updateComment: PropTypes.func,
	deleteComment: PropTypes.func
});

module.exports = CommentLine;



// WEBPACK FOOTER //
// ./modules/components/social/comments/CommentLine.js